<template>
    <div class="bgwall" :style="{'background-color':color}">
        <slot name="row1" ></slot>
        <slot name="row2"></slot>
    </div>
</template>
<script>
export default {
    props:{
        color:String
    }
}
</script>
<style lang="scss" scoped>
.bgwall{
    height: 100%;
    width:100%;
    display: flex;
    flex-direction: column;

}
</style>